/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit API Key" |
*
* @param {Options_Api_Keys_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_edit_title = /** @type {((inputs?: Options_Api_Keys_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier la clé API")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel bearbeiten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica chiave API")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать ключ API")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar clave API")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑 API 密钥")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキーを編集")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी संपादित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar chave de API")
	return /** @type {LocalizedString} */ ("Edit API Key")
});